import { Button } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useSaveWorkflow } from '../hooks/useSaveWorkflow';
import styled from 'styled-components';
import { useState } from 'react';
import { AddCampaignNameModal } from './modals/AddCampaignNameModal';
import { useCampaignSettings } from '../tabs/CampaignWorkflowTab/state/CampaignSettings/hooks/useCampaignSettings';
import { useHasUnsavedChanges } from '../tabs/CampaignWorkflowTab/state/CampaignSettings/selectors/useHasUnsavedChanges';

const Footer = styled.div`
  background-color: ${({ theme }) => theme.vars.newColor.white};
  padding: 8px 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export function CampaignFooterArea() {
  const { name } = useCampaignSettings();
  const { t } = useTranslation('campaigns');

  const saveWorkflow = useSaveWorkflow();
  const hasUnsavedChanges = useHasUnsavedChanges();
  const [addCampaignNameModalOpen, setAddCampaignNameModalOpen] = useState(false);

  const onTestButtonClicked = () => {
    if (name.length <= 0) {
      setAddCampaignNameModalOpen(true);
    } else {
      saveWorkflow();
    }
  };

  return (
    <>
      <Footer>
        <Button
          variation="primary"
          onClick={onTestButtonClicked}
          disabled={!hasUnsavedChanges}
          ariaLabel={t('onsite.saveAriaLabel')}
        >
          {t('onsite.save')}
        </Button>
      </Footer>
      <AddCampaignNameModal
        open={addCampaignNameModalOpen}
        onClose={() => {
          setAddCampaignNameModalOpen(false);
        }}
      />
    </>
  );
}
